<script lang="ts" setup>
import projectStore from '@/store/ProjectStore'
import ButtonSet from '@/components/ButtonSet.vue'
import formStore from '@/store/FormStore'
import { ValidatorType } from '@/helper/ValidateDirective'
import { ButtonSetProps, EnergySource } from '@/helper/Types'
import SectionHeadline from '@/components/SectionHeadline.vue'

const props = defineProps<{
  validator: ValidatorType
  energySourcesButtonProps: ButtonSetProps[] | undefined
}>()

defineExpose({
  validator: props.validator
})

function heatSourceChanged() {
  if (formStore.data.heatSource !== EnergySource.AIR) {
    formStore.data.heatPumpPlacement = ''
  }
}
</script>

<template>
  <section class="form__section has--line section--heat-source">
    <div class="form__section-inner">
      <SectionHeadline class="form__title" translation-key="step_heating_details.title_heat_source" />

      <ButtonSet
        key="button-set-heat-source"
        v-model="formStore.data.heatSource"
        v-validate="projectStore.projectProperties.heatSource.formValidationRule"
        :buttons="energySourcesButtonProps"
        :error-text="validator.heatSource?.error"
        :label="$t('step_heating_details.info_heat_source')"
        :large="true"
        :required="projectStore.formPropertyIsRequired('heatSource')"
        name="heat-source"
        @change="heatSourceChanged"
      />
    </div>
  </section>
</template>
